var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppButton',{staticClass:"login-button",attrs:{"variant":_vm.$options.ButtonVariant.outline,"size":_vm.$options.ButtonSize.small,"label":_vm.label},on:{"click":function($event){return _vm.$emit('click', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }